<script setup lang="ts">
import type { ResponsiveImageType } from "vue-datocms";
import type { ImageFileField, TestimonialRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ testimonial: TestimonialRecord }>();
</script>

<template>
  <div class="p-lg h-full rounded-lg bg-white">
    <div class="mb-lg flex">
      <span class="text-lg font-semibold" v-html="testimonial.quote" />
      <img src="/icons/quote-icon.svg" alt="" class="size-lg md:size-3xl">
    </div>

    <div class="gap-md flex items-center">
      <DatocmsImage v-if="testimonial.personImage as ImageFileField" :data="testimonial.personImage?.responsiveImage as ResponsiveImageType" />
      <div>
        <span class="block text-lg font-semibold">{{ testimonial.personName }}</span>
        <span class="text-sm font-medium">{{ testimonial.personTitle }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
